module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-th-TH.50a3403c.jpg";